let client_id = '193783315287-d3823kclq15ad833qgeh3d48ne8fhdgd.apps.googleusercontent.com';

const loadScript = (id, src, callback) => {
    const script = document.createElement('script');
    script.id = id;
    script.src = src;
    script.async = true;
    script.defer = true;
    script.onload = callback;
    script.onerror = (e) => {
        console.error(`Failed to load script - ${src}`, e);
    };
    
    document.head.appendChild(script);
};


const createOneTapScript = (callback, element_id) => {
    return new Promise(async (resolve, reject) => {
        if(document.getElementById('google-one-tap')) {
            resolve('already_exists');
            return;
        };

        let token = getGoogleTokenFromLocalStorage();
        if(token) {
            callback({ credential: token, cached: true });
            return;
        }

        loadScript('google-one-tap', 'https://accounts.google.com/gsi/client', () => {
            google.accounts.id.initialize({
                client_id,
                auto_select: true,
                use_fedcm_for_prompt: true,
                context: 'signin',
                callback
            });

            google.accounts.id.prompt();
            google.accounts.id.renderButton(document.getElementById(element_id), { theme: 'outline', size: 'large' });
            resolve('show_login_button');
        });
    });
}

const isGsuiteUser = () => {
    let g = localStorage.getItem('gsuite_auth');
    return g == 'true';
}

const setGsuiteUser = (enabled = true) => {
    if(enabled) {
        localStorage.setItem('gsuite_auth', 'true');
    }
    else {
        localStorage.removeItem('gsuite_auth');
    }
}

const getGoogleToken = async () => {
    let auth2 = window.gapi.auth2.getAuthInstance();
    let user = await auth2.signIn();
    return user.getAuthResponse().id_token;
}

const saveGoogleTokenForTenMinutes = (token) => {
    if(token.cached) return;
    var exp = new Date().getTime() + 600000;
    localStorage.setItem('google-token', JSON.stringify({ token: token.credential, exp }));
}

function getGoogleTokenFromLocalStorage() {
    var i = localStorage.getItem('google-token');
    if(!i) return null;
    
    var item = JSON.parse(i);
    var now = new Date().getTime();
    
    if(now > item.exp) {
        localStorage.removeItem('google-token');
        return null;
    }

    return item.token;
}

export default {
    createOneTapScript,
    isGsuiteUser,
    setGsuiteUser,
    getGoogleToken,
    saveGoogleTokenForTenMinutes
}


// WEBPACK FOOTER //
// ./src/framework/GoogleAuth.js